module.exports = __webpack_public_path__ + "static/media/file-txt.55f6b048.svg";